import React from 'react';
import { IMAGES } from '../data/offer';
export function Revelation() {
  return <section className="w-full bg-navy-950 text-white" data-id="element-124" data-mp="3szs2vajbordg">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:py-24" data-id="element-125" data-mp="3t0ba9xbcjxd8">
        <div data-id="element-126" data-mp="1rxgh9dsupdh">
          <h2 className="font-display text-2xl font-extrabold leading-tight tracking-tight sm:text-4xl" data-id="element-127" data-mp="6kgw0bw1rukx">
            El secreto no está en el brazo. Está en la{' '}
            <span className="text-lime-400" data-id="element-128" data-mp="bja9437f9jkk">ocupación de espacios</span>.
          </h2>
          <div className="mt-6 space-y-5 text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-129" data-mp="fjkbl5w09ruo">
            <p data-id="element-130" data-mp="klje6djx8kqk">
              Después de analizar cientos de partidos de nivel profesional y amateur, destilamos
              todas las estrategias complejas en un{' '}
              <strong className="font-semibold text-white" data-id="element-131" data-mp="2mceffkwwdc4o">Sistema Visual de Respuesta Rápida</strong>.
            </p>
            <p data-id="element-132" data-mp="2rbh9ybf93zye">
              No es un libro de historia: es un manual de guerra táctica que te dice exactamente
              dónde pararte y hacia dónde tirar la bola en cada situación.
            </p>
          </div>
        </div>
        <figure className="overflow-hidden rounded-2xl border border-white/10 bg-navy-900" data-id="element-133" data-mp="3coyhxmh67hyb">
          <img src={IMAGES.diagram} alt="Diagrama táctico del tercer golpe cayendo dentro del Kitchen" className="w-full" data-id="element-134" data-mp="37s8312h3qseh" />
          <figcaption className="border-t border-white/10 px-5 py-4 text-sm text-white/60" data-id="element-135" data-mp="4a6mm4xkk9cp">
            Ejemplo del sistema: trayectoria del tercer golpe suave y avance coordinado hacia la
            línea de no-volea.
          </figcaption>
        </figure>
      </div>
    </section>;
}